import apiRequest from "../../helpers/apiRequest";

export default async (slug, passedDate) => {
    return await apiRequest({
        method: 'get',
        url: `accounts/tutor_schedule/`,
    })
}
